import clsx from 'clsx';
import { useEffect } from 'react';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import { tv } from 'tailwind-variants';

export interface ModalProps extends ReactModalProps {
  modalRef?: React.RefObject<HTMLDivElement | null>;
}

const modalTV = tv({
  slots: {
    modal:
      'absolute left-1/2 top-1/2 flex max-h-[90%] min-w-[360px] max-w-[90%] -translate-x-1/2 -translate-y-1/2 transform  flex-col overflow-auto rounded-md bg-sem-l-surf-primary outline-none',
    modalBeforeClose: 'animate-slideDown',
    modalAfterOpen: 'animate-slideUp',
    overlay:
      'fixed left-0 top-0 z-50 size-full bg-black bg-opacity-[0.12] opacity-0 transition-opacity duration-200 ease-in-out',
    overlayBeforeClose: '!opacity-0',
    overlayAfterOpen: 'opacity-100',
    head: 'flex items-center justify-between px-6 py-4',
    body: 'flex flex-col gap-y-6 px-4 pb-10 pt-4',
    footer: 'flex items-center justify-center gap-x-6 p-4',
  },
});

const { modal, modalBeforeClose, modalAfterOpen, overlay, overlayAfterOpen, overlayBeforeClose } = modalTV();

export const Modal: React.FC<ModalProps> = ({ children, className, modalRef, isOpen, ...props }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <ReactModal
      isOpen={isOpen}
      contentRef={(instance) => {
        if (modalRef) {
          modalRef.current = instance;
        }
      }}
      ariaHideApp={false}
      className={{ base: clsx(modal(), className), afterOpen: modalAfterOpen(), beforeClose: modalBeforeClose() }}
      overlayClassName={{ base: overlay(), afterOpen: overlayAfterOpen(), beforeClose: overlayBeforeClose() }}
      closeTimeoutMS={200}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      {...props}
    >
      {children}
    </ReactModal>
  );
};

export const setAppElement = (selector: string) => {
  ReactModal.setAppElement(selector);
};
